
<style>

.card-grid-operators{
  margin: 32px !important;
}

</style>

<template>
  <div>
    <v-card class="card-grid-operators">
      <div>
        <grid
          newLabel="Aggiungi"
          :headers="headers"
          :CanCreate="true"
          title="Operators-Procedures"
          controller="GridElement/"
          readAll="GetOperatorsProcedures"
          create="Create"
          edit="Create"
          delete="OperatorsProcedures/DeleteOperatorProcedure"
          v-on:refreshMenu="updateMenu"
          :hideColumns=
            "[
              'Id',
              'Surname',
              'OperatorName',
              'OperatorId',
              'ProcedureId',
              'Mail'
            ]"/>
      </div>
    </v-card>
  </div>
</template>

<script>
import grid from "../../components/gridComponent.vue";

export default {

  components: {
    grid,
  },
  
  data () {
    return {
      headers: [ 
        { text: 'Operatore', value: 'Fullname' },
        { text: 'Procedura', value: 'ProcedureName' },
      ],
    };
  },

  methods: {
    updateMenu() {
      this.$emit("refreshMenu", true);
    }
  }

}
</script>
